import { createStore } from 'vuex'

export default createStore({
  // データの入れ物
  state: {
    windowPosition: 0,
    audioSelectedFlag: false,
    audioBeforeFlag: null,
    audioSwitchFlag: null,
    melodySwitchFlag: null,
  },
  getters: {
    getWindowPosition: state => {
      return state.windowPosition
    },
    getAudioSelectedFlag: state => {
      return state.audioSelectedFlag
    },
    getAudioBeforeFlag: state => {
      return state.audioBeforeFlag
    },
    getAudioSwitchFlag: state => {
      return state.audioSwitchFlag
    },
    getMelodySwitchFlag: state => {
      return state.melodySwitchFlag
    },
  },
  mutations: {
    setWindowPosition(state, select) {
      state.windowPosition = select
    },
    setAudioSelectedFlag(state, select) {
      state.audioSelectedFlag = select
    },
    setAudioBeforeFlag(state, select) {
      state.audioBeforeFlag = select
    },
    setAudioSwitchFlag(state, select) {
      state.audioSwitchFlag = select
    },
    setMelodySwitchFlag(state, select) {
      state.melodySwitchFlag = select
    },
  },
  actions: {
  },
  modules: {
  }
})
